export function trackingForProfileRoutes(commonGuard) {
  return [
    {
      path: 'tracking/springboard/profile/:tenantProfileId',
      component: () =>
        import('@/features/tracking/trackingForProfile/gnz/TrackingForProfileViewGNZ.vue'),
      beforeEnter: commonGuard,
    },
  ]
}
